/**
 * `Promise.withResolvers()` is ES2024: Chrome shipped it in 119, Safari in 17.4
 * and Firefox in 121 - all above the browsers our build still targets.
 *
 * pdf.js 5 calls it from a class field initializer, and `getDocument()` builds a
 * `new PDFDocumentLoadingTask()` on its eleventh line - so on an older browser
 * the very first appendix throws before any of it renders. This is the crash
 * Sentry reports as a TypeError in `pdf.mjs getDocument`.
 *
 * Applied to the worker's global scope too - see `browser-shims.ts`.
 */

// Marks this file a module so `declare global` below is a legal augmentation.
export {};

declare global {
  interface PromiseConstructor {
    withResolvers<T>(): {
      promise: Promise<T>;
      resolve: (value: T | PromiseLike<T>) => void;
      reject: (reason?: unknown) => void;
    };
  }
}

if (typeof Promise.withResolvers !== "function") {
  Promise.withResolvers = function withResolvers<T>() {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: unknown) => void;

    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });

    return { promise, resolve, reject };
  };
}
